import {
  EDIT_COPY,
  INVITE_COPY,
  PENDING_INVITE_COPY,
  STAFF_SETTINGS_COPY,
  STAFF_TRANSITION_COPY,
} from './adminManage';
import { INVITE_ACTION_ERROR_COPY, REQUEST_ERROR_COPY } from './invites';
import { CONCIERGE_ACCESS_ERROR_COPY, MEMBER_RECORD_COPY } from './memberRecord';
import { CONCIERGE_THREAD_COPY, WARM_INTRO_COPY } from './messages';
import { SCORING_COPY } from './scoring';
import { STATUS_ERROR_COPY } from './statusActions';

type TNotification = {
  success?: string;
  error?: string;
  errorCopy?: Record<string, string>;
  isErrorHandled?: boolean;
};

const NOTIFICATIONS = {
  activationCopy: { isErrorHandled: true },
  activationResend: { isErrorHandled: true },

  applicantArchive: { success: 'Archive status updated' },
  applicantStatus: { success: 'Status updated', errorCopy: STATUS_ERROR_COPY },
  applicantReview: { success: 'Review submitted', isErrorHandled: true },
  declineNoteSave: { success: 'Decline note saved', isErrorHandled: true },
  applicantApprove: { success: 'Applicant approved', isErrorHandled: true },
  applicantReturn: { success: 'Returned for rework', isErrorHandled: true },
  applicantReject: { success: 'Applicant rejected', isErrorHandled: true },
  applicantReorder: { isErrorHandled: true },
  applicantAssignConcierge: { success: 'Concierge assigned' },
  applicantAssignRecruiter: { success: 'Applicant reassigned', isErrorHandled: true },
  applicantSeen: { isErrorHandled: true },

  holdOpen: { success: 'Sent to Further Review', isErrorHandled: true },
  holdPass: { success: 'Marked as passed', isErrorHandled: true },
  holdFail: { success: 'Marked as failed', isErrorHandled: true },

  assessmentSave: { success: SCORING_COPY.saved, isErrorHandled: true },
  interviewRelease: { success: 'Applicant returned to booking', isErrorHandled: true },
  interviewComplete: { success: 'Interview marked as completed', isErrorHandled: true },
  conciergeSessionComplete: { success: MEMBER_RECORD_COPY.accessOpened, errorCopy: CONCIERGE_ACCESS_ERROR_COPY },
  noteAdd: { isErrorHandled: true },

  memberRole: { success: 'Member type changed', isErrorHandled: true },
  memberReassign: { success: 'Member reassigned', isErrorHandled: true },
  membersTransfer: { isErrorHandled: true },
  memberSeen: { isErrorHandled: true },

  moderatePhoto: { isErrorHandled: true },
  moderatePrompt: { isErrorHandled: true },
  moderateBio: { isErrorHandled: true },
  moderateWork: { isErrorHandled: true },

  deckQueue: { success: 'Deck queued', isErrorHandled: true },
  // TODO(dev1/TEST-DROPS): test-only past-dated deck, remove before release
  deckQueueTest: { success: 'Test deck queued — out on next app open', isErrorHandled: true },
  deckCardRemove: {},
  introSend: { success: WARM_INTRO_COPY.sent, isErrorHandled: true },

  memberThreadSync: { error: CONCIERGE_THREAD_COPY.notMoved },
  conciergeBookSync: { error: CONCIERGE_THREAD_COPY.booksNotMoved },

  inviteRevoke: { success: 'Invitation revoked', errorCopy: INVITE_ACTION_ERROR_COPY },
  onboardingRequestPass: { success: 'Request passed', errorCopy: REQUEST_ERROR_COPY },
  onboardingRequestExtend: { isErrorHandled: true },
  inviteEmailSend: { isErrorHandled: true },
  inviteIssue: { isErrorHandled: true },
  inviteReissue: { isErrorHandled: true },

  staffInvite: { success: INVITE_COPY.sent, isErrorHandled: true },
  staffInviteReissue: { isErrorHandled: true },
  staffInviteRevoke: { success: PENDING_INVITE_COPY.revoked, isErrorHandled: true },
  staffRegister: { isErrorHandled: true },
  staffAvailability: { success: EDIT_COPY.saved, isErrorHandled: true },
  staffFactorsReset: { success: EDIT_COPY.totpReset, isErrorHandled: true },
  staffTransitionPreview: { isErrorHandled: true },
  staffTransition: { success: STAFF_TRANSITION_COPY.applied, isErrorHandled: true },

  setStaffCalendar: { isErrorHandled: false },
  unlinkStaffCalendar: { success: STAFF_SETTINGS_COPY.calendarUnlinked, isErrorHandled: true },

  authSignIn: { isErrorHandled: true },
  authSignOut: {},
  authPasswordResetRequest: { isErrorHandled: true },
  authPasswordUpdate: { isErrorHandled: true },
  authTotpVerify: { isErrorHandled: true },
  authTotpReset: { success: 'Two-step reset — set it up again' },
} satisfies Record<string, TNotification>;

type TNotificationKey = keyof typeof NOTIFICATIONS;

export type {
  TNotification,
  TNotificationKey,
};
export {
  NOTIFICATIONS,
};
